import { paletteVars } from "@app/ui";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { installErrorReports } from "./ops/report";
import "./styles.css";

// Colour lives in one place (packages/ui palette); tokens.css reads it from the root.
for (const [name, value] of Object.entries(paletteVars()))
  document.documentElement.style.setProperty(name, value);

installErrorReports();

const root = document.getElementById("root");
if (root) createRoot(root).render(<App />);
